/**
 * 图片加载处理
 * Author stephen_zhou
 */
export const imagePreview = {
    inserted(el) {
      var img = new Image();
      img.src = el.firstChild.src;
  
      if (!el.firstChild.src) return;
      let width_ = el.getBoundingClientRect().width;
      let height_ = el.getBoundingClientRect().height;
      // 创建一个loading的img标签
      let loadDiv = document.createElement("div");
      let loadImg = document.createElement("img");
      loadDiv.classList.add("img-loading");
      loadImg.src = require("@/assets/img-handle/loading.gif");
      loadDiv.style.display = "flex";
      loadDiv.style.justifyContent = "center";
      loadDiv.style.alignItems = "center";
      loadDiv.style.position = "absolute";
      loadDiv.style.width = "inherit";
      loadDiv.style.height = "inherit";
      loadDiv.style.background = "#fff";
      loadDiv.style.top = "50%";
      loadDiv.style.left = "50%";
      loadDiv.style.transform = 'translate(-50%, -50%)';
      loadDiv.appendChild(loadImg);
      el.appendChild(loadDiv);  // 插入dom
      el.style.background = "#F0F4F8";
  
      img.onload = () => {
        el.removeChild(loadDiv); // 加载成功移除loading
        el.style.background = "";
      };
      // 原图片加载出错
      img.onerror = () => {
        // 故意做的延时方便展示
        setTimeout(() => {
          el.classList.add("display-flex");
          el.style.display = "flex";
          el.style.justifyContent = "center";
          el.style.alignItems = "center";
          el.style.background = "#999";
          el.innerHTML = `<span style="color: #fff;text-align: center">
          <img style="margin-bottom: 4px" src="${require('@/assets/img-handle/error.png')}"></img>
          <br />
          图片加载失败
          </span>`;
        }, 1000)
      };
    },
    update(el) {
      var img = new Image();
      setTimeout(() => {
        img.src = el.firstChild.src;
      }, 1000)
      img.onerror = () => {
        el.classList.add("display-flex");
        el.style.display = "flex";
        el.style.justifyContent = "center";
        el.style.alignItems = "center";
        el.style.background = "#999";
        el.innerHTML = `<span style="color: #fff;text-align: center">
        <img style="margin-bottom: 4px" src="${require('@/assets/img-handle/error.png')}"></img>
        <br />
        图片加载失败
        </span>`;
      };
    }
  };